require("./src/styles/global.css")

require("typeface-montserrat")
require("typeface-raleway")
